<div class="container-fluid py-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h4 class="mb-1">Policy Gap Analysis</h4>
      <p class="text-muted mb-0 small">AI-powered analysis of your security documentation against operational evidence</p>
    </div>
  </div>

  <app-page-tabs
    [tabs]="tabs"
    [activeTab]="activeTab()"
    (tabChange)="onTabChange($event)"
  ></app-page-tabs>

  <div class="mt-4">
    @switch (activeTab()) {
      @case ('repository') {
        <app-repository-hub
          [documents]="documents()"
          [aggregateReport]="aggregateReport()"
          [isLoading]="isLoading()"
          (documentSelected)="onDocumentSelected($event)"
          (viewAggregate)="onViewAggregate()"
          (documentUploaded)="onDocumentUploaded($event)"
        ></app-repository-hub>
      }
      @case ('aggregate') {
        @if (aggregateReport()) {
          <app-aggregate-view
            [aggregateReport]="aggregateReport()!"
            [documents]="documents()"
            (drillIntoDomain)="onViewDrilldown($event)"
          ></app-aggregate-view>
        }
      }
      @case ('drilldown') {
        <app-analysis-drilldown
          [findings]="allFindings()"
          [documents]="documents()"
          [filterDomain]="drilldownFilterDomain()"
          [filterDocumentId]="drilldownFilterDocumentId()"
        ></app-analysis-drilldown>
      }
    }
  </div>
</div>

<!-- Document Detail Dialog -->
@if (showDocumentDetail() && selectedDocument()) {
  <app-document-detail
    [document]="selectedDocument()!"
    [findings]="allFindings()"
    (viewFindings)="onViewDrilldown($event)"
    (closed)="onCloseDocumentDetail()"
  ></app-document-detail>
}
